//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "DetailTopPart",
  data() {
    return {
      detail: {},
      info: [],
    };
  },
  props: {
    orderId: {
      type: String,
    },
  },
  mounted() {
    this.getOrderSettleDetail();
  },
  methods: {
    /**
     * @descripttion: 获取订单详情
     * @Author: juanjuanhui
     * @Date: 2021-11-25 10:45:30
     * @param {*}
     */
    getOrderSettleDetail() {
      this.$http.village
        .getOrderSettleDetail({ id: this.orderId })
        .then((res) => {
          this.detail = res.data;
          this.info = [res.data];
        });
    },
  },
};
